/** @format */

import React from "react";
import { useOutletContext } from "react-router-dom";
import DashboardCard from "./DashboardCard";
import AddEdit from "../contentEditor/addEdit";
import FeatureFlag from "../featureFlag/FeatureFlag";
import ActionButtons from "../actionButtons/ActionButtons";
import "./Dashboard.scss";
import { Lesson, Resource, UserResource } from "../resources/types";
import { useAppSelector } from "../../app/hooks";
import { selectIsEditable } from "../editable/editableSlice";
import { useTranslation } from "react-i18next";

const Dashboard = () => {
  const resource: Resource | UserResource = useOutletContext();
  const isEditable = useAppSelector(selectIsEditable());
  const { t: _ } = useTranslation();

  return (
    <div className="bg-white rounded mt-3">
      <div className="card p-4">
        <AddEdit action="lesson" itemId={`0`} />
        {resource && resource.Object.lessons.length > 0 ? (
          resource.Object.lessons.map((lesson: Lesson, index) => (
            <div className="position-relative" key={index}>
              <FeatureFlag flag={["editable", "contenteditor", "dev"]}>
                <ActionButtons
                  action="lesson"
                  parentUUID={""}
                  itemUUID={lesson.uuid}
                  tools={["order", "edit", "delete"]}
                />
              </FeatureFlag>
              <div className="dashboard-card card mt-4 mb-5">
                <DashboardCard lesson={lesson} index={index} />
              </div>
              <AddEdit action="lesson" itemId={`${index + 1}`} />
            </div>
          ))
        ) : (
          <div className="no-items-message d-flex w-100 justify-content-center flex-column text-center py-5">
            <h2>{_("This resource currently has no lessons")}</h2>
            {isEditable && (
              <p>{_("To add a lesson press the '+' button above.")}</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
